
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: "Position",
components: {
Cell
},
computed: {
position() {
return this.$store.getters.getPosition;
}
}
};



// WEBPACK FOOTER //
// ./src/components/Position.vue